import { z } from "zod";

const COPY = {
  ar: { addToSale: "إضافة إلى البيع", attach: "ربط", barcodeSaved: "سيُحفظ هذا الرمز مع الصنف الجديد.", catalogItem: "صنف من الكتالوج", createNew: "جديد", intro: "أدخل سعر البيع فقط. يمكن لفريق المخزون إضافة التكلفة والكمية لاحقاً.", notLinked: "الرمز غير مرتبط", numericBarcode: "امسح رمز منتج رقمياً.", setPrice: "تحديد السعر", title: (name) => `بيع «${name}»`, useOrCancel: "استخدم هذا الرمز أو ألغِه." },
  en: { addToSale: "Add to sale", attach: "Attach", barcodeSaved: "This barcode will be saved with the new item.", catalogItem: "Catalog item", createNew: "New", intro: "Enter the selling price only. Inventory staff can add cost and stock later.", notLinked: "Barcode not linked", numericBarcode: "Scan a numeric product code.", setPrice: "Set price", title: (name) => `Sell "${name}"`, useOrCancel: "Use this code or cancel it." },
  fr: { addToSale: "Ajouter à la vente", attach: "Associer", barcodeSaved: "Ce code-barres sera enregistré avec le nouvel article.", catalogItem: "Article du catalogue", createNew: "Nouveau", intro: "Saisissez uniquement le prix de vente. Le stock et le coût peuvent être ajoutés plus tard.", notLinked: "Code-barres non associé", numericBarcode: "Scannez un code produit numérique.", setPrice: "Définir le prix", title: (name) => `Vendre « ${name} »`, useOrCancel: "Utilisez ce code ou annulez-le." },
  ha: { addToSale: "Ƙara zuwa sayarwa", attach: "Haɗa", barcodeSaved: "Za a ajiye wannan barcode tare da sabon kaya.", catalogItem: "Kaya daga jerin kayayyaki", createNew: "Sabo", intro: "Shigar da farashin sayarwa kawai. Ma’aikacin kaya zai iya ƙara kuɗin siya da adadi daga baya.", notLinked: "Ba a haɗa barcode ba", numericBarcode: "Duba lambar kaya mai lambobi.", setPrice: "Saita farashi", title: (name) => `Sayar da “${name}”`, useOrCancel: "Yi amfani da lambar ko soke ta." },
  ig: { addToSale: "Tinye na ire", attach: "Jikọọ", barcodeSaved: "A ga-echekwa barcode a na ihe ọhụrụ.", catalogItem: "Ihe sitere na katalọgụ", createNew: "Ọhụrụ", intro: "Tinye naanị ọnụ ahịa ire. Ndị na-ahụ maka ngwa ahịa nwere ike itinye ọnụ ahịa na ọnụọgụ ma e mesịa.", notLinked: "Ejikọtaghị barcode", numericBarcode: "Nyochaa koodu ngwaahịa ọnụọgụ.", setPrice: "Tọọ ọnụ ahịa", title: (name) => `Ree “${name}”`, useOrCancel: "Jiri koodu a ma ọ bụ kagbuo ya." },
  pt: { addToSale: "Adicionar à venda", attach: "Associar", barcodeSaved: "Este código será guardado com o novo artigo.", catalogItem: "Artigo do catálogo", createNew: "Novo", intro: "Introduza apenas o preço de venda. O custo e o stock podem ser adicionados mais tarde.", notLinked: "Código não associado", numericBarcode: "Leia um código numérico de produto.", setPrice: "Definir preço", title: (name) => `Vender “${name}”`, useOrCancel: "Use este código ou cancele-o." },
  sw: { addToSale: "Ongeza kwenye mauzo", attach: "Unganisha", barcodeSaved: "Msimbo huu utahifadhiwa na bidhaa mpya.", catalogItem: "Bidhaa kutoka orodha", createNew: "Mpya", intro: "Weka bei ya kuuza pekee. Wahudumu wa bidhaa wanaweza kuongeza gharama na idadi baadaye.", notLinked: "Msimbo haujaunganishwa", numericBarcode: "Changanua msimbo wa bidhaa wa nambari.", setPrice: "Weka bei", title: (name) => `Uza “${name}”`, useOrCancel: "Tumia msimbo huu au ughairi." },
  yo: { addToSale: "Fi kun tita", attach: "So pọ", barcodeSaved: "A yoo fi barcode yii pamọ pẹlu ọja tuntun.", catalogItem: "Ọja lati katalogi", createNew: "Tuntun", intro: "Tẹ iye tita nikan. Oṣiṣẹ ọja le fi iye rira ati iye ọja kun nigbamii.", notLinked: "A ko so barcode", numericBarcode: "Ṣayẹwo koodu ọja oninọmba.", setPrice: "Ṣeto iye", title: (name) => `Ta “${name}”`, useOrCancel: "Lo koodu yii tabi fagilee rẹ." },
  zu: { addToSale: "Engeza ekuthengiseni", attach: "Xhumanisa", barcodeSaved: "Le bhakhodi izogcinwa nento entsha.", catalogItem: "Into esohlwini", createNew: "Okusha", intro: "Faka intengo yokuthengisa kuphela. Abasebenzi besitoko bangangeza izindleko nenani kamuva.", notLinked: "Ibhakhodi ayixhunyiwe", numericBarcode: "Skena ikhodi yomkhiqizo enezinombolo.", setPrice: "Setha intengo", title: (name) => `Thengisa i-“${name}”`, useOrCancel: "Sebenzisa le khodi noma uyikhansele." },
};

function requiredNumber(value) {
  const text = String(value ?? "").trim();
  return text ? Number(text) : undefined;
}

export function getQuickSellCopy(language) {
  return { ...COPY.en, ...(COPY[language] ?? {}) };
}

export function normalizeQuickSellName(value) {
  return String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function normalizeQuickSellBarcode(value) {
  return String(value ?? "").trim().replace(/\s+/g, "");
}

export function isValidQuickSellBarcode(value) {
  return /^\d+$/.test(normalizeQuickSellBarcode(value));
}

export function getQuickSellSuggestions(products, globalProducts, query, limit = 4) {
  const normalizedQuery = normalizeQuickSellName(query);
  if (!normalizedQuery) return { global: [], local: [] };

  const local = products
    .filter((product) => normalizeQuickSellName(product.name).includes(normalizedQuery))
    .slice(0, limit);
  const localNames = new Set(products.map((product) => normalizeQuickSellName(product.name)));
  const global = globalProducts
    .filter((product) => {
      const normalizedName = normalizeQuickSellName(product.normalizedName || product.name);
      return !localNames.has(normalizedName) && normalizedName.includes(normalizedQuery);
    })
    .slice(0, Math.max(0, limit - local.length));

  return { global, local };
}

export function createQuickSellSchema(copy) {
  return z.object({
    barcode: z.string().trim().optional(),
    name: z.string().trim().min(1, copy.validation.productNameRequired),
    price: z.preprocess(
      requiredNumber,
      z.number({
        required_error: copy.validation.priceRequired,
        invalid_type_error: copy.validation.priceValid,
      }).positive(copy.validation.priceAboveZero)
    ),
  });
}

export function buildQuickSellProduct({ barcode, name, price }) {
  const normalizedBarcode = normalizeQuickSellBarcode(barcode);
  return {
    barcode: normalizedBarcode || null,
    cost: 0,
    lowStockAt: 5,
    name: String(name ?? "").trim(),
    price: Number(price),
    stock: null,
    stockTrackingEnabled: false,
  };
}

export function isProductSetupNeeded(product) {
  if (!product) return false;
  const cost = Number(product.cost);
  const price = Number(product.price);
  return !Number.isFinite(cost)
    || cost <= 0
    || !Number.isFinite(price)
    || price <= 0
    || product.stockTrackingEnabled === false
    || product.stock === null
    || product.stock === undefined;
}

export function getInventoryDraftNumber(product, field) {
  const value = product?.[field];
  if (value === null || value === undefined) return "";

  // Quick-sell products intentionally persist zero cost and may be returned
  // with a zero stock projection while tracking is disabled. Those values mean
  // "not configured", so the setup form should show its hint instead of a
  // value the user must first erase.
  if (field === "cost" && Number(value) <= 0) return "";
  if (field === "stock" && product?.stockTrackingEnabled === false) return "";

  return String(value);
}
